import React from 'react'

const SvgPillOutline = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width='1em' height='1em' viewBox='0 0 24 24' {...props}>
    <path d='M3.535 3.535c1.017-1.017 4.243-2.828 7.071 0l9.901 9.9c1.413 1.414 2.497 4.574 0 7.072-2.497 2.497-5.657 1.414-7.071 0l-9.901-9.9c-2.828-2.83-1.017-6.055 0-7.072zm1.414 1.414c-1.489 1.49-.707 3.536 0 4.243l4.243 4.242 4.242-4.242-4.242-4.243c-.707-.707-2.753-1.49-4.243 0zm14.113 14.143c1.49-1.49.707-3.535 0-4.243l-4.242-4.242-4.243 4.242 4.243 4.243c.707.707 2.753 1.49 4.242 0z' />
  </svg>
)

export default SvgPillOutline
